module.exports = __webpack_public_path__ + "img/kaist_main2.e1f95382.jpg";